<template>
  <div class="px-3" v-loading="loading">
    <page-header title="Manifest" breadcrumb="Dashboard > Bookings & Shipments > Dispatch Management > Manifest"
      :back="-1" />
    <div>
      <div class=" bg-white rounded-lg p-0" id="printable">
        <div class="actions" v-if="showAction">
          <div>
            <p>Actions</p>
            <hr />
          </div>
        </div>

        <div class="top_list">
          <div class="top_list_item">
            <p class="top_list_item_img">
              <img class="" src="../../../../assets/images/icons/number-hash-icon.png" />
            </p>
            <p class="top_list_item_title">
              Dispatch ID: #{{ manifest?.dispatchReference }}
            </p>
          </div>

          <div class="top_list_item">
            <p class="top_list_item_img">
              <img src="../../../../assets/images/icons/list-icon.png" />
            </p>
            <p class="top_list_item_title">
              Shipment Count: {{ manifest?.totals?.shipmentCount }}
            </p>
          </div>

          <div class="top_list_item">
            <p class="top_list_item_img">
              <img src="../../../../assets/images/icons/list-icon.png" />
            </p>
            <p class="top_list_item_title">
              Item Count: {{ manifest?.totals?.itemCount }}
            </p>
          </div>

          <div class="top_list_item">
            <p class="top_list_item_img">
              <img src="../../../../assets/images/icons/weight-icon.png" />
            </p>
            <p class="top_list_item_title">
              Total weight: {{ manifest?.totals?.totalWeight }}
            </p>
          </div>

        </div>
        <div class="col-span-1 p-4 mt-4 flex gap-4 text-white" style="background: #09b78a">
          <div class="rounded-full text-center w-16 h-16 bg-white inline-flex justify-center items-center">
            <img class="mx-auto block mt-0 w-7/12 h-7/12" src="../../../../assets/images/icons/fluent-tag-icon.png" />
          </div>
          <div class="flex flex-col">
            <p class="font-semibold text-xl">Standard Shipping</p>
            <span>This order has been shipped to the customer</span>
          </div>
        </div>

        <div class="flex justify-between mt-4 px-4 p-3" @click="collapsed = !collapsed" style="background: #f9fafc">
          <p class="font-semibold">Dispatch Information</p>
          <p class="flex gap-2 items-center cursor-pointer" v-if="collapsed">
            <span>
              <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.6466 8.5L13.7644 7.38219L6.88219 0.5L0 7.38219L1.11781 8.5L6.88219 2.73562L12.6466 8.5Z"
                  fill="#10233E" />
              </svg>
            </span>
            Collapse
          </p>
          <p class="flex gap-2 items-center cursor-pointer" v-else>
            <span>
              <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.6466 0.5L13.7644 1.61781L6.88219 8.5L0 1.61781L1.11781 0.5L6.88219 6.26438L12.6466 0.5Z"
                  fill="#321C3B" />
              </svg>
            </span>
            Expand
          </p>
        </div>
        <div v-if="collapsed" style="background-color: #f9fafc" class="p-4">
          <div class="lg:flex p-2 pl-3 mb-3 rounded-lg borrder border-gray-400 w-full">
            <div class=" w-full md:w-1/2 mb-3">
              <h3 class="text-green mb-3">VEHICLE INFO</h3>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap">
                  <span class="w-auto">Vehicle No:</span>
                </p>
                <p class="w-2/3 font-semibold text-left ">
                  {{ manifest?.vehicleInfo?.vehicleNo || 'N/A' }}
                </p>
              </div>

              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap">
                  <span>Driver:</span>
                </p>
                <p class="w-2/2 font-semibold text-left">
                  {{
                    manifest?.vehicleInfo?.driver || "N.A"
                  }}
                </p>
              </div>

              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap">
                  <span>Contact No:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">
                  {{
                    manifest?.vehicleInfo?.contactNo || "N?A"
                  }}
                </p>
              </div>

              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span class=" whitespace-nowrap">Vehicle
                    Capacity:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ amountFomatter(manifest?.vehicleInfo?.vehicleCapacity) ||
                  'N/A' }} Tonnes
                </p>
              </div>
            </div>
            <div class=" w-full md:w-1/2 mb-3">
              <h3 class="text-green mb-3">SHIPPING SERVICE</h3>

              <div class="detailsItem justify-start">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Name:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.shippingService?.name || 'N/A' }}</p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Businness Address:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.shippingService?.businessAddress || 'N/A' }}</p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Phone Number:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.shippingService?.phoneNumber || 'N/A' }}</p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Email Address:</span></p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.shippingService?.emailAddress || 'N/A' }}</p>
              </div>
            </div>
          </div>
          <hr class="my-3 mt-4" />
          <div class="lg:flex p-2 pl-3">
            <div class=" w-full md:w-1/2 mb-3">
              <h3 class="text-green mb-3">FROM</h3>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Name:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.origin?.name }}</p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Name:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.origin?.locationCode }}</p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Address:</span> </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.origin?.address }}, {{ manifest?.origin?.city }},
                  {{ manifest?.origin?.state }}</p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Dispatched by</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.dispatchedBy?.firstname }} {{
                  manifest?.dispatchedBy?.lastname }}</p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Contact No:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.origin?.manager?.mobile_no }}</p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Contact Email:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.origin?.manager?.email }}</p>
              </div>
            </div>
            <div class=" w-full md:w-1/2 mb-3">
              <h3 class="text-green mb-3">TO</h3>

              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap">
                  <span>Name:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">
                  {{ manifest?.destination?.name }}
                </p>
              </div>
               <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Name:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.destination?.locationCode }}</p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap">
                  <span>Email:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">
                  {{ manifest?.destination?.manager?.email }}
                </p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap">
                  <span>Manager:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.destination?.manager?.firstname }} {{
                  manifest?.destination?.manager?.lastname }}</p>
              </div>
              <div class="detailsItem">
                <p class="w-1/3 text-gray-500 flex flex-wrap">
                  <span>Contact No:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.destination?.manager?.mobile_no }}</p>
              </div>
              <div class="flex flex-wrap">
                <p class="w-1/3 text-gray-500 flex flex-wrap">
                  <span>Contact Email:</span>
                </p>
                <p class="w-2/3 font-semibold text-left">{{ manifest?.destination?.manager?.email }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class=" w-full overflow-auto">
        <div class=" table_roll">
          <div
            class="mt-5 table-header flex flex-nowrap bg-[#E5E5E5] text-md justify-around p-4 pl-11 border-y-1 border-[#D9D5EC] overflow-wrap text-[#383F51] ">
            <p class="w-3/12 text-[#383F51]">SHIPPING REF.</p>
            <p class="w-3/12 ml-2">PART OF (CONS ID #)</p>
            <p class="w-3/12 ml-2">COUNTER</p>
            <p class="w-5/12 ml-2">DESCRIPTION</p>
            <p class="w-3/12 ml-2">LOAD WEIGHT</p>
            <p class="w-3/12 ml-2">SHIPPING SERVICE</p>
            <p class="w-4/12 ml-2">SHIPPING INSTRUCTION</p>
            <p class="w-4/12 ml-2">EST. DELIVERY DATE</p>
          </div>
          <TablerowBase class="mt-3 mb-3" v-for="(shipping) in getShippings" :key="shipping.id" :count="itemCount"
            :total="getShippings.length"
            :consolidationReference="manifest && manifest.consolidation && manifest.consolidation.consolidationReference"
            @refetch-shipping="$emit('refetch-shipping')" :shipping="shipping"
            :shippingService="manifest.shippingService" />
        </div>
      </div>

      <!-- <pagination-control /> -->
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
// import PaginationControl from "@/components/UI/NewPagination";
import TablerowBase from "./modules/tableRow.vue";

export default {
  components: {
    PageHeader,
    // PaginationControl,
    TablerowBase,
  },
  props: ["back"],
  data() {
    return {
      collapsed: true,
      showAction: false,
      shareLinkModal: false,
      loading: false,
      fleet: {},
      manifest: {},
      showupdateModal: false,
      toLocation: {},
    };
  },
  computed: {
    getShippings() {
      return this.manifest?.shipments || []
    },
    recieverName() {
      const allRecievers = this.manifest?.consolidation?.shippings.reduce((total, item) => {
        const receivers = item.shipmentReceiever || [];

        const names = receivers.reduce((sum, receiver) => {
          const name = receiver?.location?.contactName;
          return name ? sum + "," + name : sum;
        }, "");

        return total + names;
      }, "");

      return (allRecievers || "").replace(/^,/, ""); // remove leading comma
    },
    getShippingName() {
      const totalPackages = this.manifest?.shipments.reduce((total, item) => {
        const receivers = item.shipmentReceiever || [];

        const count = receivers.reduce((sum, receiver) => {
          return sum + (receiver.packagees?.length || 0);
        }, "");

        return total + count;
      }, 0);

      return totalPackages;
    },
    getNumberOfPackage() {
      const totalPackages = this.manifest?.consolidation?.shippings.reduce((total, item) => {
        const receivers = item.shipmentReceiever || [];

        const count = receivers.reduce((sum, receiver) => {
          return sum + (receiver.packagees?.length || 0);
        }, 0);

        return total + count;
      }, 0);

      return totalPackages;
    },
    getAllTotalWeight() {
      const totalWeight = this.manifest?.consolidation?.shippings.reduce((total, item) => {
        return total + (item.shipmentReceiever || []).reduce((sum, receiver) => {
          return sum + (receiver.packagees || []).reduce((pkgSum, pkg) => {
            const weight = Number(pkg.estimatedWeight) || 0;
            const qty = pkg.quantity || 0;
            return pkgSum + (weight * qty);
          }, 0);
        }, 0);
      }, 0);

      return totalWeight
    },
    getTotalWeight() {
      let weight = 0;
      this.manifest?.dispatch?.consolidation?.shippings.forEach((x) => {
        x.packagees.forEach((y) => {
          weight += y.estimatedWeight * y.quantity;
        });
      });

      let convertRate = 907.185;
      let fullWeight = weight / convertRate;

      return fullWeight.toString().slice(0, 5);
    },
  },
  mounted() {
    this.getDispatchManifest();
  },
  methods: {
    printElement() {
      var $printSection = document.getElementById("printable");

      if (!$printSection) {
        $printSection = document.createElement("div");
        $printSection.id = "printSection";
        document.body.appendChild($printSection);
      }

      window.print();
    },
    performAction(action) {
      if (action == "print") {
        this.printElement();
      } else if (action == "share") {
        this.shareLinkModal = true;
      } else if (action == "statusmodal") {
        this.showupdateModal = true;
      }
    },
    toggleAction() {
      this.showAction = !this.showAction;
    },
    async getDispatchManifest() {
      this.loading = true
      try {
        const response = await this.$_getmanifestDispatchDetails(this.$route.params.dispatchID, { dispatchType: this.$route.query?.type });
        this.manifest = response.data.data
      } catch (error) {
        this.generateToast(error)
      } finally {
        this.loading = false
      }
    },
    async viewManifest() {
      this.loading = true;
      try {
        const response = await this.$_viewManifest(this.fleet.id);
        if (response.data.success) {
          this.loading = false;
          this.fleet = response.data.data.fleetDetails;
        }
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
    formatAddress(address) {
      if (typeof address === "object" && address !== null) {
        return address.name;
      }
      return address;
    },
    returnItemsWeights(packageItems) {
      const packageWeights = [];
      packageItems.forEach((item) => {
        if (item.weight) {
          packageWeights.push(item.weight);
        }
      });
      const weight = packageWeights.join(", ");
      return weight ? weight : "N.A";
    },
    returnPackageDescription(packageItems) {
      const packageDescriptions = [];
      packageItems.forEach((item) => {
        packageDescriptions.push(item.description);
      });
      return packageDescriptions.join(", ");
    },
  },
};
</script>

<style lang="scss" scoped>
.table_roll {
  @apply min-w-[1200px]
}

.detailsItem {
  @apply flex flex-wrap mb-1
}

.top_list_item_title {
  @apply font-semibold flex-1 mt-1 text-base
}

.top_list_item_img {
  @apply mt-1 -mr-8 w-14
}

.top_list_item {
  @apply w-full sm:w-6/12 md:w-1/4 px-4 flex flex-wrap justify-evenly border-r-2 border-gray-200 items-center gap-2 mt-3 mb-3 lg:mb-0
}

.top_list_item:nth-last-child(1) {
  @apply border-r-0
}

.top_list {
  @apply w-full flex flex-wrap items-center
}

.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  padding: 0.75rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 10rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }

  >div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}

.table-header {
  border-bottom: 1px solid #e1e3ea;

  p {
    color: #383f51;
    opacity: 0.5;
  }
}
</style>
